<section class="overflow-x-clip rounded-xl border border-cmi-gray-light bg-white">
  <button
    type="button"
    (click)="toggle()"
    [attr.aria-expanded]="expanded()"
    [class.rounded-b-xl]="!expanded()"
    class="flex w-full cursor-pointer items-center gap-3 rounded-t-xl px-3 py-2.5 text-left hover:bg-cmi-gray-light">
    <span class="min-w-0 flex-1">
      <span class="block text-xs font-medium tracking-wide text-cmi-gray-mid uppercase">
        {{ title() }}
      </span>
      @if (summary(); as picked) {
        <span class="block truncate text-sm font-medium text-cmi-gray">{{ picked }}</span>
      } @else if (placeholder()) {
        <span class="block truncate text-sm text-cmi-gray-mid">{{ placeholder() }}</span>
      }
    </span>

    @if (summary() && !expanded()) {
      <svg
        class="h-5 w-5 shrink-0 text-main"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    }

    <svg
      class="h-5 w-5 shrink-0 text-cmi-gray-mid transition-transform duration-200"
      [class.rotate-180]="expanded()"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  @if (expanded()) {
    <div class="border-t border-cmi-gray-light p-3">
      <ng-content />
    </div>
  }
</section>
